import React, { useState, useRef, useEffect } from "react"
import {Link} from "react-router-dom";

export default function DriveRenameCard({ data, lang, onRename }) {

    const [name, setName] = useState(data?.oldName || "")
    const inputRef = useRef(null)
    const linkValue = data.link.from

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.select()
        }
    }, [])

    if (!data) return null

    let linkSmall = new URL(data.link.from).host + new URL(data.link.from).pathname, flag = false
    if (linkSmall.includes('www')) {
        linkSmall = linkSmall.split('www.')[1]
    }

    const borderThumb = data.fileType === 'google-file' ? 'solid 2px gray' : ''

    const handleSubmit = () => {
        if (onRename) onRename(name)
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSubmit()
        }
    }

    if (data.thumb && data.thumb.includes("link-logo-default")) {
        flag = true
    }

    return (
        <div style={{ padding: 20 }}>

            {data.thumb && (
                <Link to={linkValue} rel={"noreferrer noopener"} target={'_blank'}>
                    <div className={'link-prop-card-thumb'}>
                        <img className={'link-prop-card-thumb-img'}
                             src={data.thumb}
                             alt="thumbnail"
                             style={{border: borderThumb}}
                        />
                    </div>
                    {flag && <p id={'p-link-from'}
                                style={{
                                    position: 'absolute',
                                    left: '42%',
                                    top: 92,
                                    width: 80,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    color: 'black'
                                }}>
                        <span id={'link-from'}>{linkSmall}</span>
                    </p>}
                </Link>
            )}

            <div className={'drive-rename-card'}>

                <div className={'drive-rename-card-input-wrapper'}>
                    <input className={'drive-rename-card-input'}
                        ref={inputRef}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder={lang.body.googleRenamePage.newName}
                    />

                    <button className={'drive-rename-card-btn'}
                        onClick={handleSubmit}
                        title={lang.body.googleRenamePage.send}>
                        ✏️
                    </button>
                </div>

            </div>
        </div>
    )
}